
          import p from "/home/nathan/goalert/web/src/app/public/logos/white/goalert-logo-white-scaled.webp"
          const prefixPath = pathPrefix + "/static/" + p
          export default prefixPath
        